<style lang="less">
.editCalendar {
  .dialog-card {
    min-width: 512px;
  }
}
</style>
<style scoped lang="less">
.editCalendar {
  border: 1px solid #454545;
  background-color: #FFF;
  width: 100%;

  .currentMonth {
    background-color: #fff !important;
  }

  .editCalendarHeader {
    padding-bottom: 5px;
    border-bottom: 1px solid #000;
    justify-content: space-around;

    .franchiseSelector {
      padding-left: 10px;
      margin-top: 10px;

      span {
        margin-right: 10px;
      }

      div {
        min-width: 275px;
        margin-top: -2px;
      }
    }

    .monthSelector {
      .fas.fa-angle-double-left, .fas.fa-angle-double-right {
        margin-top: 6px;
      }

      &.mobile {
        justify-content: space-around;
      }

      margin-top: 5px;
      font-size: 24px;
      text-align: center;
    }
  }

  .fieldGroupContainer {
    padding-bottom: 30px;
  }

  .fieldGroupContainer:last-of-type {
    padding-bottom: 0;
  }

  .v-select.single.open .selected-tag {
    position: relative !important;
  }

  .fieldItemContainer {
    padding-bottom: 10px;

    .label {
      min-width: 25%;
    }
  }

  .editCalendarBody {
    width: 100%;
  }

  .mobile .dayPartitionHeader {
    width: 100%;
  }

  .dayPartitionHeader {
    font-size: 0.9rem;
    text-align: center;
    border-bottom: 1px solid #000;
    border-right: 1px solid #000;
    width: (100% / 7);

    &:last-child {
      border-right: 0;
    }
  }

  .venueHeader.landscape {
    display: block !important;

    span {
      display: block;

      &:nth-child(2) {
        text-align: center;
      }
    }
  }

  .dayPartitionFooter {
    height: 45px;
  }

  .dayPartitionEvents {
    font-size: 0.65rem;

    .event {
      padding: 5px;
      background-color: #FFFFE0;
      border-top: 1px solid #000;
      cursor: pointer;

      &:last-of-type {
        border-bottom: 1px solid #000;
      }

      &:hover .toolbar {
        display: flex !important;
      }

      .toolbar {
        b {
          cursor: pointer;
        }

        cursor: default;
        display: none !important;
        justify-content: space-between;
        margin-left: -5px;
        margin-top: 0;
        margin-right: -5px;
        padding-top: 5px;
        background-color: #C3C3C3;
        position: relative;
        top: 5px;
        padding-bottom: 5px;
        padding-left: 15px;
        padding-right: 15px;
      }

      .sessionTimes {
        &.landscape {
          padding-left: 15px;
        }

        display: flex;
        justify-content: space-between;
        padding-left: 28px;
        flex-wrap: wrap;

        .sessionTime {
          &.isCanceled {
            text-decoration: line-through;
            color: red;
          }

          padding-right: 10px;
        }
      }
    }

    .tournamentMark {
      width: 20px;
      background-color: #4267b2;
      color: #FFF;
      text-align: center;
      border-radius: 25px;
      height: 20px;
      padding-top: 2px;
      margin-left: 3px;
      margin-right: 5px;
      margin-top: -2px;
    }

    .cancelMark {
      width: 20px;
      background-color: red;
      color: #FFF;
      text-align: center;
      border-radius: 25px;
      height: 20px;
      padding-top: 2px;
      margin-left: 3px;
      margin-right: 5px;
      margin-top: -2px;
    }
  }

  .sessions {
    select {
      border: 2px solid #abc;
    }
  }

  .dayPartition {
    background-color: #efefef;

    &:hover > .dayPartitionFooter > .addEventButton {
      display: block;
      opacity: 1;
    }

    &.currentDay {
      .dateSpan {
        span {
          padding: 6px;
          border-radius: 20px;
          background-color: #4267b2;
          color: #FFF;
        }
      }
    }

    position: relative;

    .dateSpan {
      span {
        position: absolute;
        right: 5px;
        top: 5px;
        text-align: center;
        display: block;
        width: 35px;
        padding: 8px;
      }

      height: 42px;
      text-align: right;
      padding-top: 5px;
      padding-right: 5px;
    }

    .addEventButton {
      display: none;
      position: absolute;
      background-color: #2196f3;
      color: #FFF;
      border-radius: 16px;
      padding: 8px;
      font-size: 1rem;
      right: 8px;
      bottom: 8px;
      cursor: pointer;
      transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
    }

    .addEventButton:hover {
      background-color: #1976d2;
    }

    border-bottom: 1px solid #000;
    min-height: 150px;
    width: (100% / 7);

    &.mobile {
      width: 100%;
    }

    border-right: 1px solid #454545;

    &:last-child {
      border-right: 0;
    }
  }
}

@media screen and (orientation: portrait) {
  .editCalendar {
    width: 90%;
    margin: 0 auto;
  }
}

@media screen and (max-width: 1023px) {
  .editCalendar .editCalendarHeader .franchiseSelector div {
    max-width: 200px !important;
    margin: 0 auto;
  }
}
</style>
<template>
  <div class="editCalendar">
    <!-- Add New Dialog -->
    <modal-dialog
        ref="addNewEventDialog"
        header-text="Add New Event"
        ok-button-text="Add Event"
        @isVisible="dialogOpened"
        @ok-button-clicked="processAdd()"
    >
      <div class="fieldGroupContainer">
        <label><strong>Venue Details</strong></label>
        <hr style="margin-top:0">
        <div class="is-flex fieldItemContainer">
          <label class="label">Franchise:</label>&nbsp;&nbsp;<v-select
            v-model="addEventData.selectedFranchise"
            :items="franchises"
            item-text="name"
            item-value="id"
            label="Select Franchise"
        />
        </div>
        <div class="is-flex fieldItemContainer">
          <label class="label">Venue:</label>
          <v-select
              v-model="addEventData.selectedVenue"
              :items="venues"
              item-text="name"
              item-value="id"
              label="Select Venue"
          />
        </div>
      </div>
      <div class="fieldGroupContainer">
        <label><strong>Scheduling</strong></label>
        <hr style="margin-top:0">
        <v-radio-group v-model="addEventData.scheduleType">
          <div>
            <v-radio
                color="primary"
                value="everyWeekday">
              <template v-slot:label>
                <strong>Every</strong>&nbsp;&nbsp;
                <v-select
                    v-model="addEventData.selectedWeekdayOfMonth"
                    :items="dayRange"
                    item-text="label"
                    item-value="id"
                    label="label"
                />&nbsp;&nbsp;of the month
              </template>
            </v-radio>
            <strong style="display:block;padding-top:10px;padding-bottom:20px;">OR</strong>
            <v-radio
                class="p-icon p-round p-jelly"
                color="primary"
                value="specificDate"
            >
              <template v-slot:label>
                <strong>Specific Date:&nbsp;</strong>
                <date-picker
                    v-model="addEventData.specificDate"
                    placeholder="Select Date"
                />
              </template>
            </v-radio>
          </div>
        </v-radio-group>
      </div>
      <div class="fieldGroupContainer">
        <label><strong>Event Tag</strong></label>
        <hr style="margin-top:0">
        <div class="fieldItemContainer is-flex">
          <label class="label">Tag</label>
          <div>
            <v-select
                v-model="addEventData.eventTag"
                :items="eventTags"
                item-text="name"
                item-value="id"
                label="Select Tag"
            />
          </div>
        </div>
      </div>
      <div class="fieldGroupContainer">
        <label><strong>Marking</strong></label>
        <hr style="margin-top:0">
        <div class="fieldItemContainer is-flex">
          <label class="label">Mark</label>
          <div>
            <v-select
                v-model="addEventData.selectedMark"
                :items="marks"
                item-text="label"
                item-value="value"
                @change="addMarkChanged"
            />
            <label v-if="addEventData.customMark"><strong>Custom Mark: &nbsp;{{
                addEventData.customMark
              }}</strong></label>
          </div>
        </div>

        <div class="is-flex fieldItemContainer">
          <label class="label">Optional Text</label>
          <input
              v-model="addEventData.optionalText"
              placeholder="Optional Text"
              class="input is-small"
              type="text"
          >
        </div>
        <div class="is-flex fieldItemContainer">
          <label class="label">Optional Link</label>
          <input
              v-model="addEventData.optionalLink"
              placeholder="Enter Optional URL"
              class="input is-small"
              type="text"
          >
        </div>
        <div class="is-flex fieldItemContainer">
          <label class="label">Notes</label>
          <textarea
              v-model="addEventData.notes"
              placeholder="Enter Notes"
              rows="5"
              cols="60"
              class=""
          />
        </div>
      </div>
      <div class="fieldGroupContainer sessions">
        <label><strong>Session Information</strong></label>
        <hr style="margin-top:0">
        <div class="is-flex fieldItemContainer">
          <v-container>
            <v-row>
              <v-label>Session 1</v-label>
            </v-row>
            <v-row>
              <v-checkbox
                  v-model="addEventData.sessions.sessionOne"
              >
              </v-checkbox>
              <v-select
                  v-model="addEventData.sessions.sessionOneHour"
                  :items="hourRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="addEventData.sessions.sessionOneMinute"
                  :items="minuteRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="addEventData.sessions.sessionOneAMPM"
                  :items="amPmRange"
              >
              </v-select>
            </v-row>
          </v-container>
        </div>
        <div class="is-flex fieldItemContainer">
          <v-container>
            <v-row>
              <v-label>Session 2</v-label>
            </v-row>
            <v-row>
              <v-checkbox
                  v-model="addEventData.sessions.sessionTwo"
              >
              </v-checkbox>
              <v-select
                  v-model="addEventData.sessions.sessionTwoHour"
                  :items="hourRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="addEventData.sessions.sessionTwoMinute"
                  :items="minuteRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="addEventData.sessions.sessionTwoAMPM"
                  :items="amPmRange"
              >
              </v-select>
            </v-row>
          </v-container>
        </div>
        <div class="is-flex fieldItemContainer">
          <v-container>
            <v-row>
              <v-label>Session 3</v-label>
            </v-row>
            <v-row>
              <v-checkbox
                  v-model="addEventData.sessions.sessionThree"
              >
              </v-checkbox>
              <v-select
                  v-model="addEventData.sessions.sessionThreeHour"
                  :items="hourRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="addEventData.sessions.sessionThreeMinute"
                  :items="minuteRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="addEventData.sessions.sessionThreeAMPM"
                  :items="amPmRange"
              >
              </v-select>
            </v-row>
          </v-container>
        </div>
        <div class="is-flex fieldItemContainer">
          <v-container>
            <v-row>
              <v-label>Session 4</v-label>
            </v-row>
            <v-row>
              <v-checkbox
                  v-model="addEventData.sessions.sessionFour"
              >
              </v-checkbox>
              <v-select
                  v-model="addEventData.sessions.sessionFourHour"
                  :items="hourRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="addEventData.sessions.sessionFourMinute"
                  :items="minuteRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="addEventData.sessions.sessionFourAMPM"
                  :items="amPmRange"
              >
              </v-select>
            </v-row>
          </v-container>
        </div>
      </div>

      <div
          v-if="isAdmin"
          class="fieldGroupContainer"
      >
        <label><strong>Show on Calendar's</strong></label>
        <hr style="margin-top:0">
        <div class="fieldItemContainer">
          <div v-for="(region, index) in regions">
            <v-checkbox
                v-model="addEventData.regionsShown[index].selected"
                class="p-icon p-square p-jelly"
                color="primary"
                name="sessionOne"
            >
              <template v-slot:label>
                {{ region.regid }} -
                {{ region.name }}
              </template>
            </v-checkbox>
          </div>
        </div>
      </div>
    </modal-dialog>

    <!-- Edit Dialog -->
    <modal-dialog
        ref="editEventDialog"
        header-text="Edit Event"
        ok-button-text="Update Event"
        @isVisible="dialogOpened"
        @ok-button-clicked="processEdit()"
    >
      <label><strong>Calendar ID {{ editEventData.calendarID }}</strong></label>
      <br><br>
      <div class="fieldGroupContainer">
        <label><strong>Venue Details</strong></label>
        <hr style="margin-top:0">
        <div class="is-flex fieldItemContainer">
          <label class="label">Franchise:</label>&nbsp;&nbsp;<v-select
            v-model="editEventData.selectedFranchise"
            item-text="name"
            item-value="id"
            :items="franchises"
        />
        </div>
        <div class="is-flex fieldItemContainer">
          <label class="label">Venue:</label>
          <v-select
              v-model="editEventData.selectedVenue"
              item-text="name"
              item-value="id"
              :items="venues"
          />
        </div>
      </div>
      <div class="fieldGroupContainer">
        <label><strong>Scheduling</strong></label>
        <hr style="margin-top:0">
        <v-radio-group v-model="editEventData.scheduleType">
          <div>
            <v-radio
                color="primary"
                value="everyWeekday">
              <template v-slot:label>
                <strong>Every</strong>&nbsp;&nbsp;
                <v-select
                    v-model="editEventData.selectedWeekdayOfMonth"
                    :items="dayRange"
                    item-text="label"
                    item-value="id"
                    label="label"
                />&nbsp;&nbsp;of the month
              </template>
            </v-radio>
            <strong style="display:block;padding-top:10px;padding-bottom:20px;">OR</strong>
            <v-radio
                class="p-icon p-round p-jelly"
                color="primary"
                value="specificDate"
            >
              <template v-slot:label>
                <strong>Specific Date:&nbsp;</strong>
                <date-picker
                    v-model="editEventData.specificDate"
                    placeholder="Select Date"
                />
              </template>
            </v-radio>
          </div>
        </v-radio-group>
      </div>
      <div class="fieldGroupContainer">
        <label><strong>Event Tag</strong></label>
        <hr style="margin-top:0">
        <div class="fieldItemContainer is-flex">
          <label class="label">Tag</label>
          <div>
            <v-select
                v-model="editEventData.eventTag"
                :items="eventTags"
                item-text="name"
                item-value="id"
                label="Select Tag"
            />
          </div>
        </div>
      </div>
      <div class="fieldGroupContainer">
        <label><strong>Marking</strong></label>
        <hr style="margin-top:0">
        <div class="fieldItemContainer is-flex">
          <label class="label">Mark</label>
          <div>
            <v-select
                v-model="editEventData.selectedMark"
                :items="marks"
                item-text="label"
                item-value="value"
                @change="editMarkChanged"
            />
            <label v-if="editEventData.customMark"><strong>Custom Mark: &nbsp;{{
                editEventData.customMark
              }}</strong></label>
          </div>
        </div>
        <div class="is-flex fieldItemContainer">
          <label class="label">Optional Text</label>
          <input
              v-model="editEventData.optionalText"
              placeholder="Optional Text"
              class="input is-small"
              type="text"
          >
        </div>
        <div class="is-flex fieldItemContainer">
          <label class="label">Optional Link</label>
          <input
              v-model="editEventData.optionalLink"
              placeholder="Enter Optional URL"
              class="input is-small"
              type="text"
          >
        </div>
        <div class="is-flex fieldItemContainer">
          <label class="label">Notes</label>
          <textarea
              v-model="editEventData.notes"
              placeholder="Enter Notes"
              class="input is-small"
          />
        </div>
      </div>
      <div class="fieldGroupContainer sessions">
        <label><strong>Session Information</strong></label>
        <hr style="margin-top:0">
        <div class="is-flex fieldItemContainer">
          <v-container>
            <v-row>
              <v-label>Session 1</v-label>
            </v-row>
            <v-row>
              <v-checkbox
                  v-model="editEventData.sessions.sessionOne"
              >
              </v-checkbox>
              <v-select
                  v-model="editEventData.sessions.sessionOneHour"
                  :items="hourRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="editEventData.sessions.sessionOneMinute"
                  :items="minuteRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="editEventData.sessions.sessionOneAMPM"
                  :items="amPmRange"
              >
              </v-select>
            </v-row>
          </v-container>
        </div>
        <div class="is-flex fieldItemContainer">
          <v-container>
            <v-row>
              <v-label>Session 2</v-label>
            </v-row>
            <v-row>
              <v-checkbox
                  v-model="editEventData.sessions.sessionTwo"
              >
              </v-checkbox>
              <v-select
                  v-model="editEventData.sessions.sessionTwoHour"
                  :items="hourRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="editEventData.sessions.sessionTwoMinute"
                  :items="minuteRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="editEventData.sessions.sessionTwoAMPM"
                  :items="amPmRange"
              >
              </v-select>
            </v-row>
          </v-container>
        </div>
        <div class="is-flex fieldItemContainer">
          <v-container>
            <v-row>
              <v-label>Session 3</v-label>
            </v-row>
            <v-row>
              <v-checkbox
                  v-model="editEventData.sessions.sessionThree"
              >
              </v-checkbox>
              <v-select
                  v-model="editEventData.sessions.sessionThreeHour"
                  :items="hourRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="editEventData.sessions.sessionThreeMinute"
                  :items="minuteRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="editEventData.sessions.sessionThreeAMPM"
                  :items="amPmRange"
              >
              </v-select>
            </v-row>
          </v-container>
        </div>
        <div class="is-flex fieldItemContainer">
          <v-container>
            <v-row>
              <v-label>Session 4</v-label>
            </v-row>
            <v-row>
              <v-checkbox
                  v-model="editEventData.sessions.sessionFour"
              >
              </v-checkbox>
              <v-select
                  v-model="editEventData.sessions.sessionFourHour"
                  :items="hourRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="editEventData.sessions.sessionFourMinute"
                  :items="minuteRange"
              >
              </v-select>
              &nbsp;
              <v-select
                  v-model="editEventData.sessions.sessionFourAMPM"
                  :items="amPmRange"
              >
              </v-select>
            </v-row>
          </v-container>
        </div>
      </div>

      <div
          v-if="isAdmin"
          class="fieldGroupContainer"
      >
        <label><strong>Show on Calendar's</strong></label>
        <hr style="margin-top:0">
        <div class="fieldItemContainer">
          <div v-for="(region,index) in regions">
            <v-checkbox
                v-model="editEventData.regionsShown[index].selected"
                class="p-icon p-square p-jelly"
                color="primary"
                name="sessionOne"
            >
              <template v-slot:label>
                {{ region.regid }} -
                {{ region.name }}
              </template>
            </v-checkbox>
          </div>
        </div>
      </div>
    </modal-dialog>

    <!-- Cancel Dialog -->
    <modal-dialog
        ref="cancelEventDialog"
        header-text="Cancel/Restore Event"
        ok-button-text="Cancel/Restore Event"
        @ok-button-clicked="processCancelRestore()"
    >
      <div class="fieldGroupContainer">
        <label><strong>Cancellation Details</strong></label>
        <hr style="margin-top:0">
        <div class="is-flex fieldItemContainer">
          <label class="label">Calendar ID:</label>&nbsp;&nbsp;{{ cancelEventData.calendarID }}
        </div>
        <div class="is-flex fieldItemContainer">
          <label class="label">Date:</label>&nbsp;&nbsp;{{ cancelEventData.visibleDate }}
        </div>
        <div class="is-flex fieldItemContainer">
          <label class="label">Venue:</label>&nbsp;&nbsp;{{ cancelEventData.venueName }}
        </div>
      </div>
      <div class="fieldGroupContainer">
        <label><strong>Scheduling</strong></label>
        <hr style="margin-top:0">
        <div class="is-flex fieldItemContainer">
          <v-radio-group v-model="cancelEventData.actionTaken">
            <v-container>
              <v-row>
                <v-col>
                  <v-radio v-if="cancelEventData.isCanceled"
                           color="primary"
                           value="restoreEvent"
                  >
                    <template v-slot:label>
                      <strong>Do not cancel event</strong>
                    </template>
                  </v-radio>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-radio
                      color="primary"
                      value="cancelEntireEvent"
                  >
                    <template v-slot:label>
                      <strong>Cancel entire event</strong>
                    </template>
                  </v-radio>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-radio
                      color="primary"
                      value="cancelSpecificSessions"
                  >
                    <template v-slot:label>
                      <strong>Cancel specific sessions</strong>
                    </template>
                  </v-radio>
                </v-col>
              </v-row>
            </v-container>
          </v-radio-group>
        </div>
        <div
            style="padding-left:60px;"
            @click="cancelEventData.actionTaken = 'cancelSpecificSessions'"
        >
          <div
              v-if="cancelEventData.sessionOneTime"
              class="is-flex fieldItemContainer"
          >
            <v-checkbox
                v-model="cancelEventData.sessionOneCancelled"
                class="p-icon p-square p-jelly"
                color="primary"
                name="sessionOne"
            >
              <template v-slot:label>
                {{ cancelEventData.sessionOneTime }}
              </template>
            </v-checkbox>
          </div>
          <div
              v-if="cancelEventData.sessionTwoTime"
              class="is-flex fieldItemContainer"
          >
            <v-checkbox
                v-model="cancelEventData.sessionTwoCancelled"
                class="p-icon p-square p-jelly"
                color="primary"
                name="sessionOne"
            >
              <template v-slot:label>
                {{ cancelEventData.sessionTwoTime }}
              </template>
            </v-checkbox>
          </div>
          <div
              v-if="cancelEventData.sessionThreeTime"
              class="is-flex fieldItemContainer"
          >
            <v-checkbox
                v-model="cancelEventData.sessionThreeCancelled"
                class="p-icon p-square p-jelly"
                color="primary"
                name="sessionOne"
            >
              <template v-slot:label>
                {{ cancelEventData.sessionThreeTime }}
              </template>
            </v-checkbox>
          </div>
          <div
              v-if="cancelEventData.sessionFourTime"
              class="is-flex fieldItemContainer"
          >
            <v-checkbox
                v-model="cancelEventData.sessionFourCancelled"
                class="p-icon p-square p-jelly"
                color="primary"
                name="sessionOne"
            >
              <template v-slot:label>
                {{ cancelEventData.sessionFourTime }}
              </template>
            </v-checkbox>
          </div>
        </div>
      </div>
    </modal-dialog>

    <div
        v-if="!receivedFranchises"
        class="spinner-loader"
    >
      <sync-loader/>
      <p>Loading ...</p>
    </div>
    <div
        v-if="receivedFranchises"
        class="editCalendarBody"
    >
      <div class="editCalendarHeader is-flex-desktop">
        <div class="franchiseSelector is-flex-desktop">
          <mq-layout mq="tablet+">
            <span class="is-hidden-mobile">Franchise: </span>
          </mq-layout>
          <v-select
              v-model="selectedFranchise"
              placeholder="Select Franchise"
              :items="franchises"
              item-text="name"
              item-value="id"
              label="name"
              @change="getCalendar"
          />
        </div>
        <div
            class="text-center monthSelector is-flex"
            :class="[{mobile: isMobile}]"
        >
          <a
              class="fas fa-angle-double-left"
              @click="backward()"
          />
          &nbsp;&nbsp;
          {{ getDate }}
          &nbsp;&nbsp;
          <a
              class="fas fa-angle-double-right"
              @click="forward()"
          />
        </div>
      </div>
      <!-- <div class="is-hidden-desktop isMobile" v-if="isMobile">
        <div class="is-flex">
        </div>
        <div v-for="(row, rowindex) in dateRange" class="is-flex">
          <div v-for="(day, index) in row"
               :class="[{ currentMonth: day.currentMonth }, 'dayPartition', 'mobile', {currentDay: day.currentDay}]">
            <div class="dayPartitionEvents">
              <draggable :list="dateRange[rowindex][index].events" :options="{sort: true}" @sort="listUpdated"
                         @start="drag=true" @end="drag=false">
                <div v-for="(element, idx) in day.events" @click="showToolbar(rowindex,index, idx)" :key="element.calid"
                     :row="rowindex" :index="index" :eventindex="idx" class="event" :calid="element.calid">
                  <div class="is-flex">
                    <span class="tournamentMark"
                          :class="{'cancelMark': element.isCanceled}">{{element.eventType}}</span>
                    <span :class="{'venueName':true, 'canceled':element.isCanceled}">{{element.name}}</span>
                  </div>
                  <div class="sessionTimes is-flex">
                    <span class="sessionTime" :class="{'isCanceled':element.isSession1Canceled}">{{element.s1}}</span>
                    <span class="sessionTime" :class="{'isCanceled':element.isSession2Canceled}">{{element.s2}}</span>
                    <span class="sessionTime" :class="{'isCanceled':element.isSession3Canceled}">{{element.s3}}</span>
                    <span class="sessionTime" :class="{'isCanceled':element.isSession4Canceled}">{{element.s4}}</span>
                  </div>
                  <div class="toolbar is-flex">
                    <b class="fas fa-edit" title="Edit Calendar Entry" @click="openEditEvent(element)"></b>
                    <b class="fas fa-ban" title="Cancel Venue/Session"
                       @click="openCancelRestoreEvent(element,day.date)"></b>
                    <b class="fas fa-trash-alt" title="Delete Calendar Entry" @click="deleteEvent(element)"></b>
                  </div>
                </div>
              </draggable>
            </div>
            <div class="dayPartitionFooter">
              <div class="addEventButton fas fa-plus" alt="Add Event" title="Add Event"
                   @click="openAddNewEvent(day.date)"></div>
            </div>
          </div>
        </div>
      </div> -->
      <div
          v-if="!receivedEvents"
          class="spinner-loader"
      >
        <sync-loader/>
        <p>Loading ...</p>
      </div>
      <div v-if="receivedEvents">
        <div
            :class="['is-flex', {mobile: isMobile && currentOrientation == 'portrait'}, {landscape: currentOrientation == 'landscape'}]">
          <div
              v-for="(day, index) in usableDayRange"
              class="dayPartitionHeader"
          >
            {{ day.label }}
          </div>
        </div>
        <div
            v-for="(row, rowindex) in dateRange"
            class="is-flex venueContainer"
        >
          <div
              v-for="(day, index) in row"
              :class="[{ currentMonth: day.currentMonth }, 'dayPartition', {mobile: isMobile && currentOrientation == 'portrait'}, {landscape: currentOrientation == 'landscape'}, {currentDay: day.currentDay}]"
          >
            <div class="dateSpan">
              <span>{{ day.date.getDate() }}</span>
            </div>
            <div class="dayPartitionEvents">
              <draggable
                  :list="dateRange[rowindex][index].events"
                  :options="{sort: true}"
                  @sort="listUpdated"
                  @start="drag=true"
                  @end="drag=false"
              >
                <div
                    v-for="(element, idx) in day.events"
                    :key="element.calid"
                    :row="rowindex"
                    :index="index"
                    :eventindex="idx"
                    class="event"
                    :calid="element.calid"
                    @click="showToolbar(rowindex,index, idx)"
                >
                  <div
                      class="is-flex venueHeader"
                      :class="[{mobile: isMobile && currentOrientation == 'portrait'}, {landscape: currentOrientation == 'landscape'}]"
                  >
                    <span
                        class="tournamentMark"
                        :class="{'cancelMark': element.isCanceled}"
                    >{{ element.eventType }}</span>
                    <span :class="{'venueName':true, 'canceled':element.isCanceled}">{{ element.name }}</span>
                  </div>
                  <div
                      class="sessionTimes is-flex"
                      :class="['is-flex', {mobile: isMobile && currentOrientation == 'portrait'}, {landscape: currentOrientation == 'landscape'}]"
                  >
                    <span
                        class="sessionTime"
                        :class="{'isCanceled':element.isSession1Canceled}"
                    >{{ element.s1 }}</span>
                    <span
                        class="sessionTime"
                        :class="{'isCanceled':element.isSession2Canceled}"
                    >{{ element.s2 }}</span>
                    <span
                        class="sessionTime"
                        :class="{'isCanceled':element.isSession3Canceled}"
                    >{{ element.s3 }}</span>
                    <span
                        class="sessionTime"
                        :class="{'isCanceled':element.isSession4Canceled}"
                    >{{ element.s4 }}</span>
                  </div>
                  <div class="toolbar is-flex">
                    <b
                        class="fas fa-edit"
                        title="Edit Calendar Entry"
                        @click="openEditEvent(element)"
                    />
                    <b
                        class="fas fa-ban"
                        title="Cancel Venue/Session"
                        @click="openCancelRestoreEvent(element,day.date)"
                    />
                    <b
                        class="fas fa-trash-alt"
                        title="Delete Calendar Entry"
                        @click="deleteEvent(element)"
                    />
                  </div>
                </div>
              </draggable>
            </div>
            <div class="dayPartitionFooter">
              <div
                  class="addEventButton fas fa-plus"
                  alt="Add Event"
                  title="Add Event"
                  @click="openAddNewEvent(day.date)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
import draggable from 'vuedraggable'
import DatePicker from '../../helpers/Datepicker.vue'
import 'pretty-checkbox/dist/pretty-checkbox.css'
import ModalDialog from '../../helpers/Dialog.vue'
import vSelect from 'vue-select'
import Vue from 'vue'
import MobileDetect from 'mobile-detect'


export default {
  name: 'ToolsEditCalendar',
  components: {
    ModalDialog,
    DatePicker,
    draggable,
  },
  props: {
    token: {
      type: String,
    },
    user: {
      type: Object,
    },
    isNew: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      eventTags: [],
      isMobile: false,
      currentOrientation: 'portrait',
      isSpecificDate: false,
      everyWeekday: false,
      receivedEvents: false,
      receivedFranchises: false,
      currentDate: null,
      mobileSelectedDate: null,
      monthStartDate: null,
      dialogOpening: false,
      monthRange: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthRangeShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      selectedMonth: null,
      selectedYear: null,
      dayRange: [{value: 0, label: 'Sunday'}, {value: 1, label: 'Monday'}, {
        value: 2,
        label: 'Tuesday'
      }, {value: 3, label: 'Wednesday'}, {value: 4, label: 'Thursday'}, {
        value: 5,
        label: 'Friday'
      }, {value: 6, label: 'Saturday'}],
      useableDayRange: [],
      dayRangeShort: [{value: 0, label: 'Sun'}, {value: 1, label: 'Mon'}, {value: 2, label: 'Tue'}, {
        value: 3,
        label: 'Wed'
      }, {value: 4, label: 'Thu'}, {value: 5, label: 'Fri'}, {value: 6, label: 'Sat'}],
      useableDayRangeShort: [],
      dateRange: [],
      hourRange: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      minuteRange: ['00', 15, 30, 45],
      amPmRange: ['AM', 'PM'],
      marks: [{value: 'Tournament', label: 'Tournament'}, {
        value: 'Special Event',
        label: 'Special Event'
      }, {value: 'Championship', label: 'Championship'}, {
        value: 'Freeroll',
        label: 'Freeroll'
      }, {value: 'other', label: 'Other (Specify)'}],
      addEventData: {
        customMark: null,
        region: null,
        selectedFranchise: null,
        selectedVenue: null,
        selectedWeekdayOfMonth: null,
        scheduleType: 'everyWeekday',
        selectedMark: 'Tournament',
        specificDate: new Date().toDateString(),
        optionalText: null,
        optionalLink: null,
        eventTag: null,
        notes: null,
        sessions: {
          sessionOne: false,
          sessionOneHour: 1,
          sessionOneMinute: '00',
          sessionOneAMPM: 'PM',
          sessionTwo: false,
          sessionTwoHour: 1,
          sessionTwoMinute: '00',
          sessionTwoAMPM: 'PM',
          sessionThree: false,
          sessionThreeHour: 1,
          sessionThreeMinute: '00',
          sessionThreeAMPM: 'PM',
          sessionFour: false,
          sessionFourHour: 1,
          sessionFourMinute: '00',
          sessionFourAMPM: 'PM',
        },
        regionsShown: []
      },
      editEventData: {
        region: null,
        customMark: null,
        selectedFranchise: null,
        selectedVenue: null,
        selectedWeekdayOfMonth: null,
        scheduleType: null,
        selectedMark: {label: 'Tournament', value: 'Tournament'},
        specificDate: new Date().toDateString(),
        optionalText: null,
        optionalLink: null,
        notes: null,
        eventTag: null,
        sessions: {
          sessionOne: false,
          sessionOneHour: 1,
          sessionOneMinute: '00',
          sessionOneAMPM: 'PM',
          sessionTwo: false,
          sessionTwoHour: 1,
          sessionTwoMinute: '00',
          sessionTwoAMPM: 'PM',
          sessionThree: false,
          sessionThreeHour: 1,
          sessionThreeMinute: '00',
          sessionThreeAMPM: 'PM',
          sessionFour: false,
          sessionFourHour: 1,
          sessionFourMinute: '00',
          sessionFourAMPM: 'PM',
        },
        regionsShown: []
      },
      cancelEventData: {
        date: null,
        visibleDate: null,
        actionTaken: 'cancelEntireEvent',
        isCanceled: false,
        calendarID: null,
        venueName: null,
        sessionOneTime: null,
        sessionTwoTime: null,
        sessionThreeTime: null,
        sessionFourTime: null,
        sessionOneCancelled: false,
        sessionTwoCancelled: false,
        sessionThreeCancelled: false,
        sessionFourCancelled: false
      },
      franchises: [],
      selectedFranchise: null,
      events: [],
      isAdmin: false,
      regions: [],
      venues: [],
      editDialogSelectedVenue: null,
      editDialogSelectedFranchise: null,
    }
  },
  computed: {
    getDate: function () {
      if (this.isMobile && this.mobileSelectedDate) {
        switch (this.currentOrientation) {
          case 'portrait':
            return this.dayRangeShort[this.mobileSelectedDate.getDay()].label + ' ' + this.monthRangeShort[this.selectedMonth] + ' ' + this.mobileSelectedDay + ' ' + this.selectedYear
          case 'landscape':
            let newEndDate = moment(this.mobileSelectedDate, 'DD-MM-YYYY').add(6, 'days')
            let month = newEndDate.format('M') - 1
            let day = newEndDate.format('DD')
            return this.monthRangeShort[this.selectedMonth] + ' ' + this.mobileSelectedDay + ' - ' + this.monthRangeShort[month] + ' ' + day + ' ' + this.selectedYear
          default:
            return this.monthRange[this.selectedMonth] + ' ' + this.selectedYear
        }
      } else {
        return this.monthRange[this.selectedMonth] + ' ' + this.selectedYear
      }
    },
    addEventDataSelectedFranchise() {
      return this.addEventData.selectedFranchise
    },
    editEventDataSelectedFranchise() {
      return this.editEventData.selectedFranchise
    }
  },
  watch: {
    selectedFranchise: function () {
      if (this.calendarStartDate) {
        this.getCalendar()
      }
    },
    addEventDataSelectedFranchise() {
      this.getVenues(this.addEventData.selectedFranchise, false)
    },
    editEventDataSelectedFranchise() {
      this.getVenues(this.editEventData.selectedFranchise, true)
    }
  },
  mounted: function () {
    let mobileDetect = new MobileDetect(window.navigator.userAgent)
    this.isMobile = mobileDetect.mobile() != null
    let self = this
    this.$nextTick(function () {
      window.addEventListener('orientationchange', function (event) {
        self.applyOrientation()
      })
    })
    if (this.isMobile) {
      this.applyOrientation()
    } else {
      this.calculateCalendarDays(new Date())
    }
    this.getFranchises()
    this.getEventTags();
  },
  methods: {
    addMarkChanged(evt) {
      if (!this.dialogOpening) {
        if ((evt.value || evt) === 'other') {
          this.addEventData.customMark = prompt('Please enter a custom tournament mark')
        } else {
          this.editEventData.customMark = null
        }
      }
    },
    getEventTags() {
      let url = `admin/tags`
      let data = {
        token: this.token
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.eventTags = [{id: null, name: "No Tag"}, ...res.data]
          })
          .catch((error) => {
            console.log(error)
          })
    },
    getStringForArray(arr) {
      let newArr = [];
      arr.forEach((element) => {
        newArr.push(element.toString())
      });
    },
    applyOrientation() {
      let self = this
      let endDate = null
      self.receivedEvents = false

      this.$nextTick(function () {
        setTimeout(function () {
          self.currentOrientation = window.matchMedia('(orientation: landscape)').matches ? 'landscape' : 'portrait'
          switch (self.currentOrientation) {
            case 'landscape':
              endDate = new Date()
              endDate.setDate(endDate.getDate() + 6)
              break
            case 'portrait':
              endDate = new Date()
              endDate.setDate(endDate.getDate())
              break
          }
          self.calculateCalendarDays(new Date(), endDate)
          if (self.selectedFranchise && (self.selectedFranchise.id || self.selectedFranchise != "" && self.selectedFranchise != null)) {
            self.getCalendar()
          }
        }, 500)
      })
    },
    dialogOpened() {
      this.dialogOpening = false
    },
    deleteEvent(element) {
      if (confirm('Are you sure you wish to delete this event?')) {
        let url = `admin/calendar/delete`
        let data = {
          token: this.token,
          franchise: typeof this.selectedFranchise === 'object' ? this.selectedFranchise.id : this.selectedFranchise,
          calendarID: element.calid
        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
            .then((res) => {
              if (res.data.message) {
                this.$emit('message',
                    {
                      showDialog: true,
                      error: res.data.error,
                      message: res.data.message
                    })
                this.getCalendar()
              }
            })
            .catch((error) => {
              console.log(error)
            })
      }
    },
    showToolbar(a, b, c) {
      var tmpEvent = this.dateRange[a][b].events[c]
      if (this.selectedEvent && tmpEvent !== this.selectedEvent) {
        this.selectedEvent.toolbarVisible = false
      }
      this.selectedEvent = this.dateRange[a][b].events[c]
      this.selectedEvent.toolbarVisible = true
    },
    listUpdated(evt) {
      this.receivedEvents = false
      var index = evt.item.getAttribute('index')
      var row = evt.item.getAttribute('row')
      this.updateListOrder(this.dateRange[row][index].events)
      this.receivedEvents = true
    },
    updateListOrder(eventList) {
      let url = `admin/calendar/displayorder`
      let data = {
        token: this.token,
        franchise: typeof this.selectedFranchise === 'object' ? this.selectedFranchise.id : this.selectedFranchise,
        eventList: eventList
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
          })
          .catch((error) => {
            console.log(error)
          })
    },
    getVenues(franchiseID, isEdit) {
      let url = `admin/tournaments/getvenuesforfranchise`
      let data = {
        token: this.token,
        franchise: franchiseID || this.selectedFranchise.id || this.selectedFranchise,
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.venues = res.data
            if (!isEdit) {
              this.addEventData.selectedVenue = res.data[0]
            }
          })
          .catch((error) => {
            console.log(error)
          })
    },
    getCalendar() {
      if (!this.calendarStartDate || !this.receivedFranchises) {
        return
      }
      this.receivedEvents = false
      this.getVenues()
      let url = `admin/calendar/get`
      let data = {
        token: this.token,
        franchise: typeof this.selectedFranchise === 'object' ? this.selectedFranchise.id : this.selectedFranchise,
        startDate: this.calendarStartDate.getFullYear() + '-' + this.addZ(this.calendarStartDate.getMonth() + 1) + '-' + this.addZ(this.calendarStartDate.getDate()),
        endDate: this.calendarEndDate.getFullYear() + '-' + this.addZ(this.calendarEndDate.getMonth() + 1) + '-' + this.addZ(this.calendarEndDate.getDate())
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.events = res.data.calendar
            this.addEventData.regionsShown = res.data.regions
            this.editEventData.regionsShown = res.data.regions
            this.regions = res.data.regions
            this.isAdmin = res.data.isAdmin
            this.processCalendar()
          })
          .catch((error) => {
            console.log(error)
          })
    },
    addZ(n) {
      return n < 10 ? '0' + n : '' + n
    },
    processCalendar() {
      this.receivedEvents = false
      for (var row = 0; row < this.dateRange.length; row++) {
        for (var day = 0; day < this.dateRange[row].length; day++) {
          this.dateRange[row][day].events = []
          var currentDay = this.dateRange[row][day].date
          var currentDayDateMySQLFormat = currentDay.getFullYear() + '-' + (this.addZ(currentDay.getMonth() + 1)) + '-' + this.addZ(currentDay.getDate())
          for (var j = 0; j < this.events.length; j++) {
            var clonedElement = JSON.parse(JSON.stringify(this.events[j]))
            clonedElement.toolbarVisible = false
            if (clonedElement.date) {
              if (clonedElement.date === currentDayDateMySQLFormat) {
                this.dateRange[row][day].events.push(clonedElement)
              }
            } else {
              var wday = currentDay.getDay()
              if (wday + '' === clonedElement.wday_mod) {
                this.dateRange[row][day].events.push(clonedElement)
              }
            }
            for (var c = 0; c < clonedElement.cancels.length; c++) {
              var cancelData = clonedElement.cancels[c]
              if (clonedElement.calid === cancelData.calid && cancelData.date === currentDayDateMySQLFormat) {
                if (this.dateRange[row][day].events.length > 0) {
                  this.dateRange[row][day].events[this.dateRange[row][day].events.length - 1].isCanceled = true
                  if (!cancelData.s1 && !cancelData.s2 && !cancelData.s3 && !cancelData.s4) {
                    this.dateRange[row][day].events[this.dateRange[row][day].events.length - 1].isSession1Canceled = true
                    this.dateRange[row][day].events[this.dateRange[row][day].events.length - 1].isSession2Canceled = true
                    this.dateRange[row][day].events[this.dateRange[row][day].events.length - 1].isSession3Canceled = true
                    this.dateRange[row][day].events[this.dateRange[row][day].events.length - 1].isSession4Canceled = true
                  } else {
                    this.dateRange[row][day].events[this.dateRange[row][day].events.length - 1].isSession1Canceled = cancelData.s1
                    this.dateRange[row][day].events[this.dateRange[row][day].events.length - 1].isSession2Canceled = cancelData.s2
                    this.dateRange[row][day].events[this.dateRange[row][day].events.length - 1].isSession3Canceled = cancelData.s3
                    this.dateRange[row][day].events[this.dateRange[row][day].events.length - 1].isSession4Canceled = cancelData.s4
                  }
                }
              }
            }
          }
        }
      }
      this.receivedEvents = true
    },
    getFranchises() {
      let url = `admin/tournaments/getfranchises`
      let data = {
        token: this.token
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.franchises = res.data
            this.selectedFranchise = res.data[0]
            this.getVenues()
            this.getCalendar()
            this.receivedFranchises = true
          })
          .catch((error) => {
            console.log(error)
          })
    },
    calculateCalendarDays(startDate, endDate) {
      this.currentDate = new Date()
      this.mobileSelectedDate = startDate
      this.mobileSelectedDay = startDate.getDate()
      this.currentDay = null
      this.dateRange = []
      var monthStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1)
      this.monthStartDate = monthStartDate
      this.selectedMonth = monthStartDate.getMonth()
      this.selectedYear = monthStartDate.getFullYear()
      var monthStartDay = monthStartDate.getDay()
      var monthEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0)
      var monthEndDay = monthEndDate.getDay()

      if (endDate) {
        this.calendarStartDate = startDate
        this.calendarEndDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())
      } else {
        this.calendarStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1 + (monthStartDay * -1))
        this.calendarEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0 + (6 - monthEndDay))
      }

      this.usableDayRange = []
      this.usableDayRangeShort = []
      // Add the end day to the diff in dates as well since it stops at 11:59 day before
      this.numDaysInCalendar = this.dateDiffInDays(this.calendarStartDate, this.calendarEndDate) + 1
      if (this.numDaysInCalendar === 0) {
        this.numDaysInCalendar = 1
      }

      var tempDate = this.calendarStartDate
      var row = 0

      for (var i = 0; i < this.numDaysInCalendar; i++) {
        if (i > 0 && (i % 7 === 0)) {
          row++
        }

        tempDate = new Date(this.calendarStartDate.getFullYear(), this.calendarStartDate.getMonth(), this.calendarStartDate.getDate() + i)
        if (!this.dateRange[row]) {
          this.dateRange.push([])
        }
        if (i <= 6) {
          this.usableDayRange.push(this.dayRange[tempDate.getDay()])
          this.usableDayRangeShort.push(this.dayRange[tempDate.getDay()])
        }

        this.dateRange[row].push({
          date: tempDate,
          currentMonth: tempDate.getMonth() === this.selectedMonth,
          currentDay: this.isEqualDateShort(tempDate, this.currentDate)
        })
      }
    },
    isEqualDateShort(date1, date2) {
      if ((date1 instanceof Date) && date2 instanceof Date) {
        if (date1.getFullYear() === date2.getFullYear()) {
          if (date1.getMonth() === date2.getMonth()) {
            if (date1.getDate() === date2.getDate()) {
              return true
            }
          }
        }
      }
      return false
    },
    resetEventData() {
      this.addEventData = {
        region: null,
        eventTag: null,
        selectedFranchise: null,
        selectedVenue: null,
        selectedWeekdayOfMonth: null,
        scheduleType: 'everyWeekday',
        selectedMark: {label: 'Tournament', value: 'Tournament'},
        specificDate: new Date().toDateString(),
        optionalText: null,
        optionalLink: null,
        notes: null,
        sessions: {
          sessionOne: false,
          sessionOneHour: 1,
          sessionOneMinute: '00',
          sessionOneAMPM: 'PM',
          sessionTwo: false,
          sessionTwoHour: 1,
          sessionTwoMinute: '00',
          sessionTwoAMPM: 'PM',
          sessionThree: false,
          sessionThreeHour: 1,
          sessionThreeMinute: '00',
          sessionThreeAMPM: 'PM',
          sessionFour: false,
          sessionFourHour: 1,
          sessionFourMinute: '00',
          sessionFourAMPM: 'PM',
        },
        regionsShown: this.regions
      }
      this.editEventData = {
        region: null,
        eventTag: null,
        selectedFranchise: null,
        selectedVenue: null,
        selectedWeekdayOfMonth: null,
        scheduleType: 'everyWeekday',
        selectedMark: {label: 'Tournament', value: 'Tournament'},
        specificDate: new Date().toDateString(),
        optionalText: null,
        optionalLink: null,
        notes: null,
        sessions: {
          sessionOne: false,
          sessionOneHour: 1,
          sessionOneMinute: '00',
          sessionOneAMPM: 'PM',
          sessionTwo: false,
          sessionTwoHour: 1,
          sessionTwoMinute: '00',
          sessionTwoAMPM: 'PM',
          sessionThree: false,
          sessionThreeHour: 1,
          sessionThreeMinute: '00',
          sessionThreeAMPM: 'PM',
          sessionFour: false,
          sessionFourHour: 1,
          sessionFourMinute: '00',
          sessionFourAMPM: 'PM',
        },
        regionsShown: this.regions
      }
      this.cancelEventData = {
        actionTaken: 'cancelEntireEvent',
        isCanceled: false,
        calendarID: null,
        venueName: null,
        sessionOneTime: null,
        sessionTwoTime: null,
        sessionThreeTime: null,
        sessionFourTime: null,
        sessionOneCancelled: false,
        sessionTwoCancelled: false,
        sessionThreeCancelled: false,
        sessionFourCancelled: false
      }
    },
    forward() {
      if (!this.isMobile) {
        this.calculateCalendarDays(new Date(this.selectedYear, this.selectedMonth + 1, 1))
      } else {
        if (this.currentOrientation === 'portrait') {
          this.calculateCalendarDays(new Date(this.selectedYear, this.selectedMonth, this.mobileSelectedDate.getDate() + 1), new Date(this.selectedYear, this.selectedMonth, this.mobileSelectedDate.getDate() + 1))
        } else {
          this.calculateCalendarDays(new Date(this.selectedYear, this.selectedMonth, this.mobileSelectedDate.getDate() + 7), new Date(this.selectedYear, this.selectedMonth, this.mobileSelectedDate.getDate() + 14))
        }
      }
      this.getCalendar()
    },
    backward() {
      if (!this.isMobile) {
        this.calculateCalendarDays(new Date(this.selectedYear, this.selectedMonth - 1, 1))
      } else {
        if (this.currentOrientation === 'portrait') {
          this.calculateCalendarDays(new Date(this.selectedYear, this.selectedMonth, this.mobileSelectedDate.getDate() - 1), new Date(this.selectedYear, this.selectedMonth, this.mobileSelectedDate.getDate() - 1))
        } else {
          this.calculateCalendarDays(new Date(this.selectedYear, this.selectedMonth, this.mobileSelectedDate.getDate() - 1), new Date(this.selectedYear, this.selectedMonth, this.mobileSelectedDate.getDate() + 7))
        }
      }
      this.getCalendar()
    },
    openCancelRestoreEvent(element, date) {
      this.resetEventData()
      var cancelData = null
      this.cancelEventData.date = date
      this.cancelEventData.visibleDate = moment(date).format('ddd MMM DD, YYYY')
      this.cancelEventData.mysqlDate = moment(date).format('YYYY-MM-DD')
      for (var i = 0; i < element.cancels.length; i++) {
        if (element.cancels[i].date === this.cancelEventData.mysqlDate) {
          cancelData = element.cancels[i]
        }
      }
      this.cancelEventData.venid = element.venid
      this.cancelEventData.calendarID = element.calid
      this.cancelEventData.venueName = element.name
      this.cancelEventData.sessionOneTime = element.s1
      this.cancelEventData.sessionTwoTime = element.s2
      this.cancelEventData.sessionThreeTime = element.s3
      this.cancelEventData.sessionFourTime = element.s4

      if (cancelData) {
        // Event IS cancelled
        this.cancelEventData.isCanceled = true
        this.cancelEventData.cancelID = cancelData.id
        this.cancelEventData.sessionOneCancelled = cancelData.s1
        this.cancelEventData.sessionTwoCancelled = cancelData.s2
        this.cancelEventData.sessionThreeCancelled = cancelData.s3
        this.cancelEventData.sessionFourCancelled = cancelData.s4

        if (!cancelData.s1 && !cancelData.s2 && !cancelData.s3 && !cancelData.s4) {
          this.cancelEventData.actionTaken = 'cancelEntireEvent'
        } else {
          this.cancelEventData.actionTaken = 'cancelSpecificSessions'
        }
      } else {
        this.cancelEventData.actionTaken = 'cancelEntireEvent'
      }

      this.$refs.cancelEventDialog.show()
    },
    openAddNewEvent(date) {
      this.resetEventData()
      this.addEventData.specificDate = date.toDateString()
      this.addEventData.selectedWeekdayOfMonth = this.dayRange[date.getDay()]
      this.addEventData.selectedFranchise = this.selectedFranchise
      for (var i = 0; i < this.addEventData.regionsShown.length; i++) {
        this.addEventData.regionsShown[i].selected = false
      }
      this.dialogOpening = true
      this.$refs.addNewEventDialog.show()
    },
    openEditEvent(element) {
      this.resetEventData()
      console.log(element)
      this.editEventData.region = element.region
      this.editEventData.selectedFranchise = {name: element.franchise_name, id: element.franchise}
      this.editEventData.selectedVenue = {name: element.name, id: element.venid}
      this.editEventData.selectedWeekdayOfMonth = parseInt(element.wday) === 7 ? this.dayRange[0] : this.dayRange[element.wday]
      this.editEventData.scheduleType = element.date ? 'specificDate' : 'everyWeekday'
      this.editEventData.specificDate = element.date
      this.editEventData.optionalText = element.opttext
      this.editEventData.optionalLink = element.opturl
      this.editEventData.eventTag = element.eventTag
      this.editEventData.notes = element.notes

      var markFound = false
      for (var m = 0; m < this.marks.length; m++) {
        if (this.marks[m].value === element.mark) {
          markFound = true
          this.editEventData.selectedMark = this.marks[m]
        }
      }

      if (!markFound) { // Custom
        this.editEventData.selectedMark = this.marks[this.marks.length - 1]
        this.editEventData.customMark = element.mark
      }

      if (element.regions_shown) {
        var regionsShown = element.regions_shown.split(',')
        for (var i = 0; i < regionsShown.length; i++) {
          for (var x = 0; x < this.regions.length; x++) {
            if (regionsShown[i] === this.regions[x].regid) {
              this.editEventData.regionsShown[x].selected = true
            }
          }
        }
      }
      var sessions = {}
      var timeSplit = []
      var timePart = null
      if (element.s1) {
        timeSplit = element.s1.split(' ')
        timePart = timeSplit[0].split(':')
        sessions.sessionOne = true
        sessions.sessionOneHour = parseInt(timePart[0])
        sessions.sessionOneMinute = timePart[1]
        sessions.sessionOneAMPM = timeSplit[1]
      }
      if (element.s2) {
        timeSplit = element.s2.split(' ')
        timePart = timeSplit[0].split(':')
        sessions.sessionTwo = true
        sessions.sessionTwoHour = parseInt(timePart[0])
        sessions.sessionTwoMinute = timePart[1]
        sessions.sessionTwoAMPM = timeSplit[1]
      }
      if (element.s3) {
        timeSplit = element.s3.split(' ')
        timePart = timeSplit[0].split(':')
        sessions.sessionThree = true
        sessions.sessionThreeHour = parseInt(timePart[0])
        sessions.sessionThreeMinute = timePart[1]
        sessions.sessionThreeAMPM = timeSplit[1]
      }
      if (element.s4) {
        timeSplit = element.s4.split(' ')
        timePart = timeSplit[0].split(':')
        sessions.sessionFour = true
        sessions.sessionFourHour = parseInt(timePart[0])
        sessions.sessionFourMinute = timePart[1]
        sessions.sessionFourAMPM = timeSplit[1]
      }
      this.editEventData.calendarID = element.calid
      this.editEventData.sessions = sessions
      this.dialogOpening = true
      this.$refs.editEventDialog.show()
    },
    dateDiffInDays(date1, date2) {
      var oneDay = 1000 * 60 * 60 * 24
      var date1Ms = date1.getTime()
      var date2Ms = date2.getTime()

      // Calculate the difference in milliseconds
      var differenceMs = date2Ms - date1Ms

      // Convert back to days and return
      return Math.round(differenceMs / oneDay)
    },
    processAdd() {
      let url = `admin/calendar/add`
      let data = {
        token: this.token,
        eventData: this.addEventData
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            if (res.data.message) {
              this.$emit('message',
                  {
                    error: res.data.error,
                    message: res.data.message
                  })
            }
            this.getCalendar()
          })
          .catch((error) => {
            console.log(error)
          })
    },
    editMarkChanged(evt) {
      debugger;
      if (!this.dialogOpening) {
        if ((evt.value || evt) === 'other') {
          this.editEventData.customMark = prompt('Please enter a custom tournament mark')
        } else {
          this.editEventData.customMark = null
        }
      }
    },
    processEdit() {
      let url = `admin/calendar/edit`
      let data = {
        token: this.token,
        eventData: this.editEventData
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            if (res.data.message) {
              this.$emit('message',
                  {
                    error: res.data.error,
                    message: res.data.message
                  })
            }
            this.getCalendar()
          })
          .catch((error) => {
            console.log(error)
          })
    },
    processCancelRestore() {
      let url = `admin/calendar/cancelrestore`
      let data = {
        token: this.token,
        eventData: this.cancelEventData
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            if (res.data.message) {
              this.$emit('message',
                  {
                    error: res.data.error,
                    message: res.data.message
                  })
            }
            this.getCalendar()
          })
          .catch((error) => {
            console.log(error)
          })
    }
  }
}
</script>
